import { render, staticRenderFns } from "./ShowTeamPositionsSlide.vue?vue&type=template&id=58fa1f7c"
import script from "./ShowTeamPositionsSlide.vue?vue&type=script&lang=js"
export * from "./ShowTeamPositionsSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports